require('./accountDebitChangeAccountInfoBox.scss');
// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ constants
const { DATE_FORMAT_CAMELCASED } = require('constants/index');
// @ helpers
const { formatDate } = require('utilities/dateHelper');
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const StringHelper = require('utilities/stringHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

const statusOption = {
    ANU: StringHelper.toFirstUppercase(formatText('accountDebits-canceled')),
    APL: StringHelper.toFirstUppercase(formatText('accountDebits-paid')),
    APR: StringHelper.toFirstUppercase(formatText('accountDebits-rejected')),
    DEV: StringHelper.toFirstUppercase(formatText('accountDebits-refunded')),
    PAB: StringHelper.toFirstUppercase(formatText('accountDebits-refunded')),
    PAN: StringHelper.toFirstUppercase(formatText('accountDebits-pending')),
    PAP: StringHelper.toFirstUppercase(formatText('accountDebits-pending')),
    PTD: StringHelper.toFirstUppercase(formatText('accountDebits-rejected')),
    PTF: StringHelper.toFirstUppercase(formatText('accountDebits-pending')),
    PTR: StringHelper.toFirstUppercase(formatText('accountDebits-pending')),
};

class AccountDebitChangeAccountInfoBox extends React.Component {

    render() {
        const { match: { params: { accountId, receiptNumber } }, immAccountDebits } = this.props;

        const receiptStatus = immAccountDebits.hasIn([accountId, 'byId', receiptNumber]);

        if (receiptStatus) {
            const receipt = immAccountDebits.getIn([accountId, 'byId', receiptNumber]);
            const date = receipt.get('date');
            const issuingCompanyName = receipt.get('issuingCompanyName');
            const formattedStatus = statusOption[receipt.get('status')];
            const plainAmountObject = getPlainAmountObject(receipt.get('amount'));

            return (
                <OKSectionBox className="account-info-box__receipt-info">
                    <h1 className="account-info-box__title">
                        <FormattedText value="accountDebitChange-infoBoxTitle" />
                    </h1>
                    <section className="account-info-box__field">
                        <h2 className="account-info-box__subtitle">
                            <FormattedText value="accountDebits-date" format="firstUppercase" />
                        </h2>
                        <div className="account-info-box__value">
                            {formatDate(date, DATE_FORMAT_CAMELCASED)}
                        </div>
                    </section>

                    <section className="account-info-box__field">
                        <h2 className="account-info-box__subtitle">
                            <FormattedText value="accountDebits-emisor" format="firstUppercase" />
                        </h2>
                        <div className="account-info-box__value">
                            {issuingCompanyName}
                        </div>
                    </section>

                    <section className="account-info-box__field">
                        <h2 className="account-info-box__subtitle">
                            <FormattedText value="accountDebits-status" format="firstUppercase" />
                        </h2>
                        <div className="account-info-box__value">
                            {formattedStatus}
                        </div>
                    </section>

                    <section className="account-info-box__field">
                        <h2 className="account-info-box__subtitle">
                            <FormattedText value="accountDebits-amount" format="firstUppercase" />
                        </h2>
                        <div className="account-info-box__value">
                            <OneLineSymbolAmount
                                amountObject={plainAmountObject}
                                language={getLanguage()}
                                amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                            />
                        </div>
                    </section>
                </OKSectionBox>
            );
        }
        else {
            return (
                <OKSectionBox className="account-info-box__receipt-info">
                    <LoadingSection />
                </OKSectionBox>
            )
        }
    }
}

AccountDebitChangeAccountInfoBox.propTypes = {
    immAccountDebits: PropTypes.object,
    immAccounts: PropTypes.object,
    match: PropTypes.object,
};

module.exports.AccountDebitChangeAccountInfoBox = AccountDebitChangeAccountInfoBox;
